import SearchIcon from "@mui/icons-material/Search";

import CardResult from "../../components/cardResult/CardResult";
import { cleanMask } from '../../helpers/HelperFunctions';
import ContainerWithSidebar from "../../components/UI/containerWithSidebar/ContainerWithSidebar";
import {
  GeneralContainer,
  H1,
  H2,
  TextLink,
  Text
} from "../../components/UI/generalLayout/Layout.styled";
import BackButton from "../../components/UI/buttons/BackButton";
import {
  SchedulingContainer,
  SchedulingFilterContainer,
  SchedulingMedicsContainer,
} from "../Scheduling/Scheduling.styled";
import LabelInput from "../../components/labelInput/LabelInput";
import { Button, CircularProgress, Radio, TextField } from '@mui/material';
import * as collaboratorInitial from "../../store/actions/collaboratorInitial";
import * as exams from "../../store/actions/exams";
import * as schedulingActions from "../../store/actions/scheduling";
import InputMask from "react-input-mask";
import { useCallback, useEffect, useState } from "react";
import { TypeCards } from "../../enums/TypeCards";
import {
  ContainerCallcenter,
  DoubleComponents,
  FlexRow,
  ViewScroll,
} from "./callCenter.styled";

import {
  UserRoleService,
  UserRoleType,
} from "../../core/http/service/UserRoleService";

import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../..";
import CollaboratorInitialModalScheduling from "../../components/collaboratorInitial/CollaboratorInitialSchedulingModal";
import { Paths } from "../../enums/Paths";
import CollaboratorInitialAllAppointments from "../../components/collaboratorInitial/CollaboratorInitialAllAppointments";
import Colors from "../../constants/Colors";
import { Calendar, Day } from "@hassanmojab/react-modern-calendar-datepicker";
import ExameCard from "../../models/core/exams/ExameCard";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import { getCodigoByDescricao, Roles } from "../../enums/Roles";
import { StyledText } from "../../components/appointmentAttendance/EncaixeModal";
import CareLineDropdown from "../../components/dropdown/CareLineDropdown";
import { PersonService } from "../../core/http/service/PersonService";
import { Spacer } from "../../components/UI/spacer/spacer";

import { ScheduleConsultType, ScheduleTimeAvailableData, SchedulingService } from "../../core/http/service/SchedulingService";
import ErrorArea from "../../components/error/ErrorArea";
import { DayValue } from "react-modern-calendar-datepicker";
import { CompanyOccupationalHealth, CompanyService } from "../../core/http/service/CompanyService";

import { ptBrCustomLocale } from "../../constants/Objects";

import SchedulingCard from "../../components/SchedulingCard/SechedulingCard";


import { default as SchedulingCardType } from "../../models/core/scheduling/SchedulingCard";
import { ILogin } from "../../store/reducers/login";
import { TitleName } from "../../components/cardInformationUser/CardInformationUser.styled";




const date = new Date();
const day: Day = {
  day: date.getDate(),
  month: date.getUTCMonth() + 1,
  year: date.getFullYear(),
};


type CompanyOccupationalHealthSelect = CompanyOccupationalHealth & {
  nome: string;
};


const validPerfil: { [value: string]: true } = {
  ENF: true,
  MED: true,
  PSI: true,
};



const CallCenter = () => {

  const [appointmentTypes] = useState<{ nome: string; id: ScheduleConsultType }[]>([
    { nome: 'Atendimento Clínico', id: 'Clinica' },
    { nome: 'Atendimento Periódico', id: 'Periodica' },
    { nome: 'Exame Preventivo', id: 'Preventiva' }
  ]);

  const [selectedAppointmentType, setSelectedAppointmentType] = useState<any>({ nome: '', id: '' })

  const [doctorTimeAvailable, setDoctorTimeAvailable] = useState<
    ScheduleTimeAvailableData[]
  >([]);


  const [selectedDay, setSelectedDay] = useState<DayValue>();

  const [search, setSearch] = useState("");

  const [modalScheduling, setModalScheduling] = useState(false);

  const [showAllAppointments, setShowAllAppointments] = useState(false);

  const [isFetchingPhoto, setIsFetchingPhoto] = useState(false);

  const [roles, setRoles] = useState<UserRoleType[]>([]);

  const userInfoId = useSelector((state: any) => state.login.userInfo.id);

  const { isDesktop, isTablet } = useResponsiveInfo();

  const dispatch = useAppDispatch();

  const { isMobile } = useResponsiveInfo();

  const [isLoadingFetchPessoa, setIsLoadingFetchPessoa] = useState(false)

  const [pessoaSelected, setPessoaSelected] = useState<any>({ id: '', nome: '', unidadeAtendimentoPermitida: true })

  const [cpf, setCpf] = useState('')

  const { state } = useLocation();

  const [selectedRole, setSelectedRole] = useState<UserRoleType>();

  const { consultType } = (state as any) ?? {};

  const [pessoasByCpfFilter, setPessoasByCpfFilter] = useState<any[]>([])

  const isUnitNotAllowed = !pessoaSelected.unidadeAtendimentoPermitida

  const [error, setError] = useState<any[]>([]);

  const [searchValidated, setSearchValidated] = useState<string>();

  const [loading, setLoading] = useState(false);

  const [modalPayload, setModalPayload] = useState<{
    pacienteId: string;
    empresaId: string;
    horarioId: string;
    tipoConsulta: string;
  } | null>(null);

  const { userInfo, currentCompany } = useSelector(
    (state: { login: ILogin }) => state.login
  );

  const [selectedOccupationalHealth, setSelectedOccupationalHealth] =
    useState<CompanyOccupationalHealthSelect>();
  const [occupationalHealths, setOccupationalHealths] = useState<
    CompanyOccupationalHealthSelect[]
  >([]);

  const onClickSearch = () => {
    if (!search || search.length > 2) {
      setSearchValidated(search || undefined);
    } else {
      setError([{ message: "O nome tem que conter mais de 3 caracteres." }]);
    }
  };

  const personService: PersonService = new PersonService();

  const resultList: SchedulingCardType[] =
    useSelector((state: any) => state.collaborationInitial.scheduling) ?? [];

  const resultExams: ExameCard[] =
    useSelector((state: any) => state.exams.exames) ?? [];

  const { currentProfile } = useSelector((state: any) => state.login);
  const [showInfo] = useState(currentProfile === getCodigoByDescricao(Roles.ADM)
    || currentProfile === getCodigoByDescricao(Roles.GES) ? false : true)


  const fetchResults = useCallback(async () => {
    await dispatch(collaboratorInitial.getResultsScheduling());
  }, [dispatch, isFetchingPhoto]);

  const fetchExames = useCallback(async () => {
    await dispatch(exams.fetchExams(userInfoId));
  }, [dispatch]);

  useEffect(() => {
    if (!isFetchingPhoto) {
      fetchResults();
      fetchExames();
    }
  }, [fetchResults, isFetchingPhoto]);

  useEffect(() => {
    if (currentCompany?.id) {
      setLoading(true);
      const service = new CompanyService();
      service
        .getUnidadeAtendimento(currentCompany.id)
        .then(({ data: { data } }) => {
          const units = data.filter(d => { return !d.inativo })
            .map((value) => ({ ...value, nome: value.nomeFantasia }));
          units.push({ nome: "Todos", id: "", nomeFantasia: "Todos", inativo: false })
          setOccupationalHealths(units);
        })
        .catch((error) => setError([error]))
        .catch((error) => setError([error]))
        .finally(() => setLoading(false));
    }
  }, [currentCompany?.id]);

  useEffect(() => {
    if (currentCompany?.id) {
      setLoading(true);
      const service = new UserRoleService();
      service
        .getAllRoles()
        .then(({ data: { data } }) => {
          const roles = data.filter(d => { return d.profissionalSaude === true });
          roles.push({
            nome: "Todos",
            id: "",
            codigo: "",
            descricao: "",
            ordem: 0,
            atribuivel: false,
            inativo: false,
            profissionalSaude: true
          })
          setRoles(roles);
        })
        .catch((error: any) => setError([error]))
        .finally(() => setLoading(false));
    }
  }, [currentCompany?.id]);

  const navigate = useNavigate();

  const onSelectSchedulingCard = (id: string) => {
    navigate(Paths.DetailScheduling, { state: { id } });
  };

  useEffect(() => {
    if (consultType) {
      const found = appointmentTypes.find(a => a.id === consultType);
      if (found) {
        setSelectedAppointmentType(found);
      }
    }
  }, [consultType, appointmentTypes]);

  useEffect(() => {
    if (selectedAppointmentType?.id) {
      dispatch(schedulingActions.setScheduleConsultType(selectedAppointmentType.id));
    }
  }, [selectedAppointmentType?.id, dispatch]);

  const handleSelectPessoa = useCallback((value: any) => {
    setPessoaSelected(value);

    // Update Redux state with selected patient info for scheduling
    dispatch(
      schedulingActions.setSchedulingPatient(
        value.pessoaId || undefined,
        value.id || undefined
      )
    );
  }, [dispatch]);

  const fetchPessoasByCpf = useCallback(async () => {
    setIsLoadingFetchPessoa(true)
    let peopleByCpf: any[] = [];
    try {
      // 1. Tenta buscar titular
      const response: any = await personService.getPessoaEmpresaByCPF(cleanMask(cpf), currentCompany?.id ?? "");
      
      const processResponse = (res: any) => {
        const list: any[] = [];
        res.data.data.forEach((data: any) => {
          data.empresas.forEach((empresa: any) => {
            const object =
            {
              nomePessoa: data.nome,
              nome: `${data.nome} - ${empresa.nome}`,
              pessoaId: data.id,
              id: empresa.id,
              nomeEmpresa: empresa.nome,
              unidadeAtendimentoPermitida: empresa.unidadeAtendimentoPermitida
            }
            list.push(object);
          })
        })
        return list;
      }

      peopleByCpf = processResponse(response);

      // 2. Se não encontrou titular, busca dependente no novo endpoint
      if (peopleByCpf.length === 0) {
        const depResponse: any = await personService.getDependenteByCPF(cleanMask(cpf), currentCompany?.id ?? "");
        peopleByCpf = processResponse(depResponse);
      }

      setPessoasByCpfFilter(peopleByCpf)
      if (peopleByCpf.length === 1) {
        handleSelectPessoa(peopleByCpf[0]);
      } else {
        handleSelectPessoa({ id: '', nome: '', unidadeAtendimentoPermitida: true });
      }
    } catch (error: any) {
      setPessoasByCpfFilter([])
    }
    setIsLoadingFetchPessoa(false)
  }, [cpf, currentCompany?.id, handleSelectPessoa])

  useEffect(() => {
    if (cleanMask(cpf).length === 11) {
      fetchPessoasByCpf();
    } else {
      setPessoasByCpfFilter([]);
      handleSelectPessoa({ id: '', nome: '', unidadeAtendimentoPermitida: true });
    }
  }, [cpf, fetchPessoasByCpf, handleSelectPessoa])

  useEffect(() => {
    if (pessoaSelected?.pessoaId) {
      dispatch(
        collaboratorInitial.getResultsSchedulingPerson(pessoaSelected.pessoaId)
      );
    } else {
      dispatch(collaboratorInitial.getResultsScheduling());
    }
  }, [pessoaSelected?.pessoaId, dispatch]);

  useEffect(() => {
    const schedulingService = new SchedulingService();

    if (
      pessoaSelected?.id &&
      userInfo?.id &&
      pessoaSelected?.pessoaId &&
      selectedAppointmentType?.id
    ) {
      setLoading(true);
      setDoctorTimeAvailable([]);

      const formattedDate = selectedDay
        ? `${selectedDay.year}-${String(selectedDay.month).padStart(2, '0')}-${String(selectedDay.day).padStart(2, '0')}`
        : undefined;

      schedulingService
        .postScheduleTimeAvailable({
          empresaId: pessoaSelected?.id ?? "",
          pacienteId: pessoaSelected?.pessoaId, // ⚠️ usa o paciente selecionado
          profissionalNome: searchValidated,
          perfilSaude: validPerfil[selectedRole?.codigo ?? ""]
            ? selectedRole?.codigo
            : undefined,
          unidadeAtendimentoId:
            selectedOccupationalHealth?.id === ''
              ? undefined
              : selectedOccupationalHealth?.id,
          data: formattedDate,
          tipoConsulta: selectedAppointmentType?.id, // ⚠️ usa o tipo selecionado
        })
        .then((value: any) => {
          setDoctorTimeAvailable(value?.data?.data ?? []);
        })
        .catch((error: any) => setError([error]))
        .finally(() => setLoading(false));
    }
  }, [
    currentCompany?.id,
    userInfo?.id,
    pessoaSelected?.pessoaId,
    pessoaSelected?.id, // 🔥 FALTAVA ISSO
    selectedAppointmentType?.id,
    searchValidated,
    selectedDay,
    selectedOccupationalHealth?.id,
    selectedRole?.codigo,
  ]);


  return (
    <ContainerWithSidebar>
      <ContainerCallcenter>
        <GeneralContainer>
          <TitleName>Central de agendamento</TitleName>
        </GeneralContainer>
        <FlexRow style={{ marginTop: "38px", marginBottom: "38px", flexDirection: "column", alignItems: "flex-start" }}>
          <StyledText>CPF do Paciente*:</StyledText>
          <div style={{ flexDirection: isMobile ? 'column' : 'row', display: 'flex' }}>
            <InputMask
              mask="999.999.999-99"
              onKeyPress={e => { e.key === 'Enter' && e.preventDefault() }}
              maskPlaceholder="" value={cpf}
              onChange={(event: any) => {
                setCpf(event.target.value)
                setDoctorTimeAvailable([])
              }
              }
            >
              <TextField error={false} placeholder="000.000.000-00" style={{ marginRight: 10, width: isMobile ? '100%' : 300 }} size="small" />
            </InputMask>
            {cleanMask(cpf).length === 11 && (
              <>
                {!isLoadingFetchPessoa ? (
                  <>
                    {pessoasByCpfFilter.length > 0 && (<CareLineDropdown
                      value={pessoaSelected}
                      onChange={handleSelectPessoa}
                      items={pessoasByCpfFilter}
                      containerStyle={{ width: isMobile ? '100%' : '', marginTop: isMobile ? 5 : 0 }}
                      style={{ width: isMobile ? '100%' : 350, height: 42 }}
                      disabled={false}
                    />)}
                  </>) : (<CircularProgress />)}
              </>)}
          </div>
        </FlexRow>
        {showAllAppointments ? (
          <ContainerCallcenter>
            <BackButton onClick={() => setShowAllAppointments(false)} />
            <CollaboratorInitialAllAppointments
              onSelectCard={onSelectSchedulingCard}
            />
          </ContainerCallcenter>
        ) : (
          <>
            {showInfo && (<div>
              <DoubleComponents>
                <H2>Consultas agendadas</H2>
                {/* <ViewAll
                  onClick={() => {
                    setShowAllAppointments(true);
                  }}
                >
                  Ver tudo <MdKeyboardArrowRight />
                </ViewAll> */}
              </DoubleComponents>

              <FlexRow>
                <ViewScroll>
                  {resultList && resultList.length > 0 && (
                    <>
                      {[...resultList]
                        .sort((a, b) =>
                          a.horario < b.horario
                            ? 1
                            : a.horario > b.horario
                              ? -1
                              : 0
                        )
                        .map((dados, index) => (
                          <CardResult
                            key={index}
                            id={dados.id}
                            render={TypeCards.CardConsulta}
                            horario={dados.horario}
                            foto={dados.profissionalFoto}
                            nomeMedico={dados.profissionalNome}
                            titulo={dados.profissionalEspecialidade}
                            unidade={dados.unidadeAtendimentoNome}
                            onClick={onSelectSchedulingCard}
                          />
                        ))}
                    </>
                  )}
                  {resultList.length === 0 && (
                    <>
                      <H1>Paciente ainda não possui consultas agendadas.</H1>
                    </>
                  )}
                </ViewScroll>
              </FlexRow>
              <FlexRow style={{ marginBottom: "38px", flexDirection: "column", alignItems: "flex-start" }}>
                <StyledText>
                  Tipo de Atendimento:
                </StyledText>
                <div style={{ flexDirection: isMobile ? 'column' : 'row', display: 'flex', justifyContent: 'center' }}>
                  {appointmentTypes.map(appointmentType => {
                    return <div style={{ flexDirection: 'row', display: 'flex', marginTop: -10, marginBottom: -10 }}>
                      <Radio
                        checked={appointmentType.id === selectedAppointmentType.id}
                        onChange={() => { setSelectedAppointmentType(appointmentType) }}
                        value={selectedAppointmentType}
                      />
                      <StyledText>{appointmentType.nome}</StyledText>
                    </div>
                  })}
                </div>
              </FlexRow>
              <DoubleComponents style={{ marginTop: "50px" }}>
                {/* <H2>Comunicados</H2> */}
                {/* <ViewAll>
                  Ver tudo <MdKeyboardArrowRight />
                </ViewAll> */}
              </DoubleComponents>
              <FlexRow
                style={{ width: isDesktop ? "100%" : isTablet ? "100%" : "" }}
              >

                <GeneralContainer>
                  <H2>Próximos horários disponíveis</H2>
                  {/* <SubTitle>Atendimento {getDescricaoByCodigoAppointmentType(consultType)}</SubTitle> */}
                  <Spacer bottom={16} />
                  <SchedulingContainer>
                    <SchedulingMedicsContainer>
                      <div>
                        <LabelInput
                          value={search}
                          placeholder="Busca nome do profissional"
                          onChangeText={(event) => {
                            setSearch(event.target.value);
                          }}
                          rightIcon={
                            <Button onClick={onClickSearch}>
                              <SearchIcon />
                            </Button>
                          }
                        />
                      </div>
                      <Spacer bottom={16} />
                      {loading ? (
                        <CircularProgress />
                      ) : doctorTimeAvailable.length <= 0 ? (
                        <Text>Nenhum resultado encontrado</Text>
                      ) : null}
                      {doctorTimeAvailable.map((item) => (
                        <>
                          <SchedulingCard data={item} key={item.id} />
                        </>
                      ))}
                    </SchedulingMedicsContainer>
                    <SchedulingFilterContainer>
                      <CareLineDropdown
                        value={selectedRole}
                        onChange={setSelectedRole}
                        items={roles}
                        disabled={false}
                        backgroundColor={Colors.SPM50}
                        textColor={Colors.SPM600}
                        placeholder="Selecione tipo de profissional"
                        containerStyle={{
                          width: "100%",
                        }}
                        allValue={undefined}
                      />

                      <CareLineDropdown
                        value={selectedOccupationalHealth}
                        onChange={setSelectedOccupationalHealth}
                        items={occupationalHealths}
                        disabled={false}
                        backgroundColor={Colors.SPM50}
                        textColor={Colors.SPM600}
                        placeholder="Selecione a unidade"
                        containerStyle={{
                          width: "100%",
                        }}
                        allValue={undefined}
                      />

                      <Calendar
                        onChange={setSelectedDay}
                        locale={ptBrCustomLocale}
                        colorPrimary={Colors.SPM600}
                        colorPrimaryLight={Colors.SPM50}
                        shouldHighlightWeekends
                        minimumDate={day}
                        value={selectedDay}
                      />
                    </SchedulingFilterContainer>
                  </SchedulingContainer>
                </GeneralContainer>
                <ErrorArea
                  errorList={error}
                  onCloseAction={() => {
                    setError([]);
                  }}
                />

              </FlexRow>
            </div>)}
          </>
        )}
      </ContainerCallcenter>
      <CollaboratorInitialModalScheduling
        modalOpen={modalScheduling}
        consultType={selectedAppointmentType.id as ScheduleConsultType}
        onCloseModal={() => setModalScheduling(false)}
      />
    </ContainerWithSidebar>
  );
};

export default CallCenter;
